module.exports = __webpack_public_path__ + "img/Tablet - 24.cc8a7261.png";